<div class="reporting-builder">
  <ng-container *ngIf="selectedLayout$ | async as selectedLayout; else loading">
    <div class="reporting-builder__top">
      <div class="reporting-builder__top__left-actions">
        <button mat-icon-button matTooltip="Go to List" [routerLink]="['../../', 'list']">
          <mat-icon svgIcon="chevron_left"></mat-icon>
        </button>
      </div>
      <h2 class="reporting-builder__top__title">Report Builder</h2>
      <div class="reporting-builder__top__info">
        <h4>
          <span
            [contentEditable]="selectedLayout?.permissions?.is_editable"
            (blur)="layoutNameBlur($event)"
            spellcheck="false"
            matTooltip="Click on me to edit"
            >{{ selectedLayout.name }}</span
          >
        </h4>
        <p data-cy="report-builder-object-type">
          <strong>Object Type:</strong>
          {{ selectedLayout.definition.related_to_type | relatedToTypeTitle: customObjects }}
          {{ selectedLayout.report_type === 'time_series' ? '(Time Series)' : null }}
        </p>
      </div>
      <div class="reporting-builder__top__right-actions">
        <p>
          Last Updated
          <br />
          {{ selectedLayout.updated_at | date }}
        </p>
        <button (click)="refresh()" [disabled]="ui.isProcessing" mat-icon-button [color]="'primary'">
          <mat-icon>refresh</mat-icon>
        </button>
        <ts-button
          class="mr-2"
          variant="primary"
          (click)="save()"
          [appAuthorize]="selectedLayout?.permissions?.is_editable"
          [disabled]="ui.isProcessing"
          >Save</ts-button
        >
        <ng-container
          *ngIf="
            ui.isTimeSeries || (canShowGroupOptions && selectedLayout.definition.groupBy?.length);
            else notTimeSeriesExportButtons
          "
        >
          <ts-button
            [appAuthorize]="NewPermission.REPORT_BUILDER_SHARING_RECORDS"
            denyAction="disable"
            variant="primary"
            icon="keyboard_arrow_down"
            [matMenuTriggerFor]="exportMenu"
            [disabled]="ui.isProcessing || !(NewPermission.REPORT_BUILDER_SHARING_RECORDS | hasPermission)"
          >
            Export
          </ts-button>
          <mat-menu #exportMenu>
            <button mat-menu-item (click)="export('pdf')">
              <span class="ml-2">PDF</span>
            </button>
            <button mat-menu-item (click)="export('xlsx')">
              <span class="ml-2">Excel</span>
            </button>
            <button mat-menu-item (click)="export('csv')">
              <span class="ml-2">CSV</span>
            </button>
            @if (selectedLayout.definition.groupBy?.length) {
              <button mat-menu-item (click)="export('csv', true)">
                <span class="ml-2">Raw Data</span>
              </button>
            }
          </mat-menu>
        </ng-container>
        <ng-template #notTimeSeriesExportButtons>
          <ts-button
            [appAuthorize]="NewPermission.REPORT_BUILDER_SHARING_RECORDS"
            denyAction="disable"
            variant="primary"
            icon="keyboard_arrow_down"
            [matMenuTriggerFor]="exportMenu"
            [disabled]="ui.isProcessing || !(NewPermission.REPORT_BUILDER_SHARING_RECORDS | hasPermission)"
          >
            Export
          </ts-button>
          <mat-menu #exportMenu>
            <button mat-menu-item (click)="export('pdf')">
              <span class="ml-2">PDF</span>
            </button>
            <button mat-menu-item (click)="export('csv')">
              <span class="ml-2">CSV</span>
            </button>
          </mat-menu>
        </ng-template>
        <button
          [appAuthorize]="NewPermission.REPORT_BUILDER_CREATE"
          denyAction="hide"
          mat-icon-button
          [matMenuTriggerFor]="moreMenu"
        >
          <mat-icon svgIcon="more_vert"></mat-icon>
        </button>
        <mat-menu #moreMenu="matMenu">
          <button mat-menu-item (click)="duplicateReport()">
            <mat-icon svgIcon="difference"></mat-icon>
            <span>Duplicate Report</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <div class="reporting-builder__middle">
      @if (NewPermission.REPORTS_BUILDER_EDIT | hasPermission) {
        <div class="reporting-builder__middle__left" [class.left-panel-hidden]="ui.isLeftPanelHidden">
          <mat-tab-group
            animationDuration="0ms"
            [class.display-none]="ui.isLeftPanelHidden"
            [(selectedIndex)]="leftTabGroupIndex"
          >
            <mat-tab label="Fields">
              <app-reporting-builder-field-selector
                [isTimeSeries]="ui.isTimeSeries"
                [fields]="fields"
                [selectedFields]="columns"
                [groupMode]="ui.isTimeSeries || hasNestedFiltersOn"
                [relatedToLabel]="relatedToLabel"
                [isTimeSeriesGrouped]="layout.definition.groupBy?.length > 0"
                [fieldFormula]="layout.report_layout_summary_formulas"
                [canEdit]="selectedLayout.permissions?.is_editable"
                (fieldsChanged)="onFieldsChanged($event)"
                (setFormulaToField)="onSetFormulaToField($event)"
              ></app-reporting-builder-field-selector>
            </mat-tab>
            <mat-tab label="Filters">
              <ng-template mat-tab-label>
                <span class="relative"
                  >Filters
                  <strong
                    *ngIf="ui.isTimeSeries && !timeSeriesFilterIsValid"
                    class="time-series-filter-badge"
                    matTooltip="Missing Start and/or End dates"
                    matTooltipPosition="after"
                    >!
                  </strong>
                </span>
              </ng-template>
              <app-reporting-builder-filter
                [definition]="selectedLayout.definition"
                [filters]="selectedLayout.filters || {}"
                [isTimeSeries]="ui.isTimeSeries"
                [fieldsFilterFn]="fieldsFilterFn"
                [canApplyFilters]="selectedLayout.permissions?.is_editable"
                (filterChanged)="onFiltersChanged($event)"
                (timeSeriesfilterChanged)="onTimeSeriesFiltersChanged($event)"
                [allowRelatedObjectFields]="hasNestedFiltersOn"
                [isReportBusy]="ui.isLoadingData"
              ></app-reporting-builder-filter>
            </mat-tab>
          </mat-tab-group>
          <button
            class="reporting-builder__middle__left__hide-button"
            mat-icon-button
            [matTooltip]="ui.isLeftPanelHidden ? 'Show left panel' : 'Hide left panel'"
            (click)="toggleLeftPanel()"
          >
            <mat-icon [svgIcon]="ui.isLeftPanelHidden ? 'chevron_right' : 'chevron_left'"></mat-icon>
          </button>
        </div>
      }
      <div
        class="reporting-builder__middle__center"
        [ngClass]="{ 'reporting-builder__middle__center--full': !(NewPermission.REPORTS_BUILDER_EDIT | hasPermission) }"
        [class.loading]="ui.isLoadingData"
        [class.left-panel-hidden]="ui.isLeftPanelHidden"
      >
        <mat-tab-group animationDuration="0ms" #centerTabGroup>
          <mat-tab label="Data">
            <app-reporting-builder-data-table
              [fields]="fields"
              [columns]="columns"
              [options]="options"
              [data]="graphqlResults$ | async"
              [isTimeSeries]="ui.isTimeSeries"
              [timeSeriesFilterIsValid]="timeSeriesFilterIsValid"
              [cadence]="selectedLayout.definition.cadence"
              [summarizeMethod]="selectedLayout.definition.summarizeMethod"
              [groupByFields]="selectedLayout.definition.groupBy"
              [groupByFieldsOptions]="dealTypeFields | filterBy: [''] : null : filterNotTimeSeries"
              [relatedToLabel]="relatedToLabel"
              [canShowGroupOptions]="canShowGroupOptions"
              [relatedToType]="selectedLayout.definition.related_to_type"
              (pageChanged)="onPageChanged($event)"
              (sortChanged)="onSortChanged($event)"
              (cadenceChanged)="onCadenceChanged($event)"
              (columnsChanged)="onColumnsChanged($event)"
              (summarizeMethodChanged)="onSummarizeMethodChanged($event)"
              (groupByFieldsChanged)="onGroupByFieldsChanged($event)"
            ></app-reporting-builder-data-table>
          </mat-tab>
          <mat-tab label="Visualization">
            <ng-container *ngIf="centerTabGroup.selectedIndex === 1">
              <app-reporting-builder-visualizations
                [layout]="selectedLayout"
                [fields]="fields"
                [columns]="columns"
                [options]="options"
                [allowRelatedObjectFields]="false"
                [isTimeSeries]="ui.isTimeSeries"
                (removeChart)="onRemoveChart($event)"
                (refreshChart)="onRefreshChart()"
              ></app-reporting-builder-visualizations>
            </ng-container>
          </mat-tab>
          <mat-tab label="Configuration">
            <app-reporting-builder-configuration
              class="block m-4"
              [layout]="selectedLayout"
              (configurationChanged)="configurationChanged($event)"
            ></app-reporting-builder-configuration>
          </mat-tab>
        </mat-tab-group>
        @if (
          centerTabGroup.selectedIndex === 1 &&
          selectedLayout.definition.visualizations?.length === 0 &&
          selectedLayout.permissions?.is_editable
        ) {
          <button
            mat-button
            class="reporting-builder__middle__center__create-visualization"
            (click)="openCreateOrEditVisualization()"
          >
            <mat-icon class="icon-size-20 mr-2" svgIcon="add_circle"></mat-icon>
            <span>Add Visualization</span>
          </button>
        }
      </div>
    </div>
  </ng-container>
  <ng-template #loading>
    <div class="ph-item height-100p">
      <div class="ph-col-12">
        <div class="ph-picture"></div>
        <div class="ph-row">
          <div class="ph-col-6 big"></div>
          <div class="ph-col-4 empty big"></div>
          <div class="ph-col-2 big"></div>
          <div class="ph-col-4"></div>
          <div class="ph-col-8 empty"></div>
          <div class="ph-col-6"></div>
          <div class="ph-col-6 empty"></div>
          <div class="ph-col-12"></div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
